const quality = "q_60";
let data = [
  {
    id: 1,
    attributes: {
      title: "Internship at Sherbrooke University, Canada",
      description: "5 months Internship in the field of AI and robustness of Machine Learning at the University of Sherbrooke",
      img: `https://res.cloudinary.com/dmgeaamqy/image/upload/${quality}/v1725376522/portfolioAssets/experiences/udes_v9qzri.jpg`,
    },
  },
  {
    id: 1,
    attributes: {
      title: "Third prize at A2SV hackathon 2023",
      description: "Secured the thrid prize of 4k $ in A2SV 2023 hackathon with Kurio project in Addis Ababa, Ethiopia",
      img: `https://res.cloudinary.com/dmgeaamqy/image/upload/${quality}/v1725376581/portfolioAssets/experiences/a2sv_xfobyg.png`,
    },
  },
  {
    id: 1,
    attributes: {
      title: "Participant in Devfest21",
      description: "Hackathon organized by GDG Algiers",
      img: `https://res.cloudinary.com/dmgeaamqy/image/upload/${quality}/v1681448349/portfolioAssets/experiences/devfest21_jflpae.jpg`,
    },
  },
  {
    id: 1,
    attributes: {
      title: "Mentor in Innobyte Hackathon",
      description: "Hackathon organized by Bytecraft held in Bejaia",
      img: `https://res.cloudinary.com/dmgeaamqy/image/upload/${quality}/v1725376569/portfolioAssets/experiences/innobyte_kulh9j.jpg`,
    },
  },
  {
    id: 2,
    attributes: {
      title: "Participant in IWD22",
      description: "Hackathon organized by WTM Algiers",
      img: `https://res.cloudinary.com/dmgeaamqy/image/upload/${quality}/v1681448359/portfolioAssets/experiences/iwd22_msjxlq.png`,
    },
  },
  {
    id: 3,
    attributes: {
      title: "Flutter trainer",
      description: "Flutter workshop during CodeRally Hackathon organized by ByteCraft",
      img: `https://res.cloudinary.com/dmgeaamqy/image/upload/${quality}/v1681448349/portfolioAssets/experiences/FlutterWorkshop_f229qt.jpg`,
    },
  },
  {
    id: 4,
    attributes: {
      title: "Participant in AiHack Tunisia 22",
      description: "International hackathon in Tunisia",
      img: `https://res.cloudinary.com/dmgeaamqy/image/upload/${quality}/v1681448355/portfolioAssets/experiences/aiHackTunisia22_eeiufp.jpg`,
    },
  },
  {
    id: 5,
    attributes: {
      title: "Participant in Haick23",
      description: "A Datathon organized by School of Ai Algiers",
      img: `https://res.cloudinary.com/dmgeaamqy/image/upload/${quality}/v1681448348/portfolioAssets/experiences/hacik23_kd0aqv.jpg`,
    },
  },
  {
    id: 6,
    attributes: {
      title: "Mentor in IWD 23",
      description: "Mentor during IWD 23 Hackathon organized by WTM Algiers",
      img: `https://res.cloudinary.com/dmgeaamqy/image/upload/${quality}/v1681448350/portfolioAssets/experiences/mentrorIwd23_eheyyi.jpg`,
    },
  },
];

export default data;
